import ManaParticle from "../../../ManaParticle"
import NodeCategories from "../../NodeCategories"
import SimpleManaNode, { SimpleManaNodeOptions } from "../../SimpleManaNode"

export type CardinalDirectionNodeOptions = { direction?: number } & SimpleManaNodeOptions

const DIRECTIONS = [
	{ symbol: '⬆', degrees: -90 },
	{ symbol: '➡', degrees: 0 },
	{ symbol: '⬇', degrees: 90 },
	{ symbol: '⬅', degrees: 180 },
]

export default class CardinalDirectionNode extends SimpleManaNode {

	direction

	static nodeName = "Cardinal direction node"
	static nodeDesc = "Sets rotation to a cardinal direction"
	static nodeIcon = '🧭'
	static category = NodeCategories.Direction
	static nodeType = 'CardinalDirectionNode'

	constructor({ direction = 0, ...rest }: CardinalDirectionNodeOptions) {
		super(rest)

		this.direction = direction
		this.symbol = this.getSymbol()
	}

	getSymbol() {
		if (this.direction === undefined) return ''
		return DIRECTIONS[this.direction].symbol
	}

	onScroll(dir: number) {
		const amt = - dir
		let nDir = this.direction + amt
		if (nDir >= DIRECTIONS.length) nDir = 0
		if (nDir < 0) nDir = DIRECTIONS.length - 1
		this.setDirection(nDir)
	}

	setDirection(direction: number) {
		this.direction = direction
		this.symbol = this.getSymbol()
		this.reloadSymbol()
	}

	async act(particle: ManaParticle) {
		if (particle.target) {
			particle.direction.rotateToDeg(DIRECTIONS[this.direction].degrees)
		}

		return true
	}

	save() {
		return {
			...super.save(),

			direction: this.direction
		}
	}

}